import styled from 'styled-components';
import { IonSpinner } from '@ionic/react';

export const IonSpinnerWrapper = styled(IonSpinner)``;
